import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import locale from '../locale/Localization';

const styles = {
  root: {
    width: '100%'
  },
  heading: {
    marginBottom: '10px'
  },
  title: {
    paddingTop: '20px',
    paddingBottom: '20px'
  },
  tableheader: {
    fontWeight: 'bold'
  },
  tableCellTh: {
    width: '50%'
  },
  list: {
    padding: '0px'
  },
  listitem: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  button: {
    marginTop: '20px'
  }
};

/**
 * Component class of CompanyDetails
 */
export default class CompanyDetails extends Component {
  /**
   * Creates a CompanyDetails
   *
   * @param {Object} props - the property data
   */
  constructor(props) {
    super(props);
    this.state = {
      companyDetails: this.props.companyDetails
    };
  }

  /**
   * Renders the element on the details page.
   *
   * @param {string} label - element's label
   * @param {string} value - element's value
   *
   * @return {string} - element to be rendered
   */
  renderDetailsComponent = (label, value) => {
    return (
      <TableRow>
        <TableCell component='th' scope='row' style={styles.tableCellTh}>
          {label}
        </TableCell>
        {value && <TableCell>{value}</TableCell>}
        {!value && <TableCell></TableCell>}
      </TableRow>
    );
  };

  /**
   * Renders company's status
   *
   * @return {string} - company status to be rendered
   */
  renderStatus = () => {
    return (
      <div id='company-status' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-status-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.status}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(
                locale.uid,
                this.state.companyDetails.uid
              )}
              {this.renderDetailsComponent(
                locale.uidStatus,
                this.state.companyDetails.companyStatus
              )}
              {this.renderDetailsComponent(locale.uidAddition, null)}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's address
   *
   * @return {string} - company address to be rendered
   */
  // eslint-disable-next-line max-lines-per-function
  renderAddress = () => {
    return (
      <div id='company-address' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-address-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.registeredOfficeAddress}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(
                locale.name,
                this.state.companyDetails.name
              )}
              {this.renderDetailsComponent(locale.additionalName, null)}
              {this.renderDetailsComponent(locale.translation, null)}
              {this.renderDetailsComponent(locale.careOf, null)}
              {this.renderDetailsComponent(
                locale.streetAndNum,
                this.state.companyDetails.address.town +
                  ' ' +
                  this.state.companyDetails.address.houseNumber
              )}
              {this.renderDetailsComponent(locale.supplement, null)}
              {this.renderDetailsComponent(
                locale.postcodeAndLocation,
                this.state.companyDetails.address.swissZipCode +
                  ' ' +
                  this.state.companyDetails.address.town
              )}
              {this.renderDetailsComponent(
                locale.canton,
                this.state.companyDetails.address.cantonAbbreviation
              )}
              {this.renderDetailsComponent(
                locale.country,
                this.state.companyDetails.address.country
              )}
              {this.renderDetailsComponent(
                locale.municipality,
                this.state.companyDetails.address.town
              )}
              {this.renderDetailsComponent(
                locale.municipalityNr,
                this.state.companyDetails.address.municipalityId
              )}
              {this.renderDetailsComponent(locale.egid, null)}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's post office info
   *
   * @return {string} - company post office info to be rendered
   */
  renderPostOffice = () => {
    return (
      <div id='company-postoffice' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-postoffice-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.postOffice}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(locale.postOfficeNumber, null)}
              {this.renderDetailsComponent(
                locale.postcodeAndPostOfficeLocation,
                null
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's other identification features
   *
   * @return {string} - company other identification features to be rendered
   */
  renderOtherIdentificationFeatures = () => {
    return (
      <div id='company-other-ident-features' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-other-ident-features-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.otherIdentificationFeatures}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(locale.legalForm, null)}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's commercial registry data
   *
   * @return {string} - company commercial registry data to be rendered
   */
  renderCommercialRegistryData = () => {
    return (
      <div id='company-commercial-registry-data' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-commercial-registry-data-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.commercialRegisterData}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(locale.statusHr, null)}
            </TableBody>
            <TableBody>
              {this.renderDetailsComponent(locale.referenceNumber, null)}
            </TableBody>
            <TableBody>
              {this.renderDetailsComponent(locale.uidPlace, null)}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's vat data
   *
   * @return {string} - company vat data to be rendered
   */
  renderVatData = () => {
    return (
      <div id='company-vat-data' style={styles.heading}>
        <TableContainer component={Paper}>
          <Table aria-label='company-vat-data-table'>
            <TableHead>
              <TableRow>
                <TableCell style={styles.tableheader}>
                  {locale.vatData}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderDetailsComponent(locale.vatRegisterStatus, null)}
            </TableBody>
            <TableBody>
              {this.renderDetailsComponent(locale.vatNumber, null)}
            </TableBody>
            <TableBody>
              {this.renderDetailsComponent(locale.uidPlace, null)}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  /**
   * Renders company's details page
   *
   * @return {string} - details page to be rendered
   */
  renderDetails = () => {
    return (
      <div id='company-details-container' style={styles.root}>
        {this.renderStatus()}
        {this.renderAddress()}
        {this.renderPostOffice()}
        {this.renderOtherIdentificationFeatures()}
        {this.renderCommercialRegistryData()}
        {this.renderVatData()}
      </div>
    );
  };

  /**
   * Renders CompanyDetails component
   *
   * @return {string} - company details component to be rendered
   */
  render() {
    return (
      <div>
        <Button
          style={styles.button}
          size='small'
          onClick={() => {
            this.props.onBackLinkClick(
              null,
              this.props.companyList,
              this.props.savedSearchValue
            );
          }}
          startIcon={<ArrowBackIosOutlinedIcon />}
        >
          {locale.back}
        </Button>
        <Typography variant='h5' gutterBottom style={styles.title}>
          {locale.coreFeature}
        </Typography>
        {this.state.companyDetails && this.renderDetails()}
      </div>
    );
  }
}

CompanyDetails.propTypes = {
  companyDetails: PropTypes.object.isRequired,
  onBackLinkClick: PropTypes.func.isRequired,
  companyList: PropTypes.array.isRequired,
  savedSearchValue: PropTypes.string.isRequired
};
